import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './Hero.css';

const Hero: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const { t } = useLanguage();
  const navigate = useNavigate();

  const performSearch = useCallback(() => {
    if (searchQuery.trim()) {
      // Navigate to jobs page with search query
      navigate(`/jobs?search=${encodeURIComponent(searchQuery.trim())}`);
    } else {
      // Navigate to jobs page without search query
      navigate('/jobs');
    }
  }, [searchQuery, navigate]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    performSearch();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      performSearch();
    }
  };

  return (
    <section className="hero">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1 className="hero-title">
          {t('hero.title1')}
        </h1>
        <h1 className="hero-title hero-highlight">
          {t('hero.title2')}
        </h1>

        <form className="hero-search" onSubmit={handleSearch}>
          <input
            type="text"
            className="search-input"
            placeholder={t('hero.search')}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <button type="submit" className="search-button">
            {t('hero.searchBtn')}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Hero;
